export default __webpack_public_path__ + "static/media/auexcd.f30e2121.png";